<div class="header">
  <!-- Router link here is default ["/"] -->
  <spb-logo title="Borgo KYC Admin"></spb-logo>
  <div [style.flex-grow]="1"></div>

  @if (service.currentUser()?.name) {
    <span>{{ service.currentUser()!.name }}</span>
    <button
      [style.margin-right.px]="50"
      [matMenuTriggerFor]="menu" mat-icon-button>
      <mat-icon>menu</mat-icon>
    </button>
  }

</div>

<mat-menu #menu="matMenu">
  <button [routerLink]="['/', 'admin']" mat-menu-item>Översikt</button>
  <button [routerLink]="['/', 'admin', 'test']" mat-menu-item>Manuellt utskick</button>
  <button (click)="service.reset()" mat-menu-item>Logga ut</button>
</mat-menu>